import React, { useEffect, useState } from "react";
import {
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  FormGroup,
  Input,
  FormFeedback,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import Tables from "views/examples/Tables";
import BookingModal from "components/Modals/BookingModal";
import toast from "../../../../components/Toastify";
import { axiosAccountInstance } from "api/Request";
import { fetchUserData } from "helpers/storageData";
import cancelIcn from "../../../../assets/img/icons/customIcons/cancel.png";
import deleteIcn from "../../../../assets/img/icons/customIcons/delete.svg";
import viewIcn from "../../../../assets/img/icons/customIcons/view.svg";
import { setPendingRequestInfo } from "redux/actions/admin/PendingRequestAction";
import { getApprovedRequestsInfo } from "redux/actions/admin/ApprovedRequestAction";
import SOWModal from "components/Modals/SOWModal";
import { updatePendingCount } from "redux/actions/admin/PendingCountRequestAction";
import { getAllBookingRequestInfo } from "redux/actions/admin/AllBookingRequestAction";
import { getAllRequestInfo } from "redux/actions/admin/AllRequestAction";
function PendingListCard({ loader ,countFetch}) {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [cancelModal,setCancelModal]=useState(false)
  const [interviewRejectReason, setInterviewRejectReason] = useState("");
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [bookingData, setBookingData] = useState({});
  const [bookingModal, setBookingModal] = useState(false);
  const [errors, setErrors] = useState(null);
  const [sowModal, setSOWModal] = useState(false);
  const [sowData, setSOWData] = useState({});
  const [rejectRequestReason, setRejectRequestReason] = useState("");
  const [sowErrors, setSOWErrors] = useState(null);
  const [signedSOWdoc, setSignedSOWdoc] = useState();
  const [isApproveButtonDisabled, setIsApproveButtonDisabled] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false); //multiple click disabled
  const [employeeID, setEmployeeID] = useState("");
  const [sowHistory, setSOWHistory] = useState([]);
  const user = localStorage.getItem("user");
  const [userData, setUserData] = useState({});
  useEffect(() => {
    setUserData(JSON.parse(user));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const fetchResultPendingListRequests = useSelector(
    (state) => state.PendingRequestReducer.result
  );
  useEffect(() => {
    setData(fetchResultPendingListRequests?.booking || []);
    
    countFetch(fetchResultPendingListRequests?.itemCount)
  }, [fetchResultPendingListRequests]);
  // TO_DO : Socket instance delete situation
  const socketInstance = useSelector((state) => state.socketReducer.result);
  const deleteHandler = (id) => {
    setDeleteId(id);
    setModal(!modal);
  };

  const onCancel = () => {
    setIsButtonDisabled(true);
    const finalData = {
      employeeId: bookingData.employeeId,
      bookingId: bookingData.bookingId,
      reason: interviewRejectReason,
    };
    cancelRequest(finalData);
  };
  const rejectValidation = (data) => {
    const errorsFound = {};
    

    if (!interviewRejectReason || interviewRejectReason === "") {
      errorsFound["interviewRejectReason"] = "Reason is required";
    }

    if (Object.keys(errorsFound).length !== 0) {
      setErrors(errorsFound);
      return false;
    }
    return true;
  };
  const cancelRequest = (data) => {
   
    const isValid = rejectValidation(data);
    if(isValid){
      axiosAccountInstance
        .post("/cancel_interview", data)
        .then((res) => {
          if (res.data.statusCode === 200) {
            
              socketInstance.emit("message", {
                type: "CANCEL_INTERVIEW_REQUEST",
                
                key: data?.bookingId,
                userId:userData.userId,
                extraInfo: fetchUserData()?.companyName,
              });
              toast.success(res.data.body.message);
            
            setCancelModal(false);
            setInterviewRejectReason("");
            
            if(res.data?.body?.data?.isInbound){
              
              dispatch(getAllBookingRequestInfo("0", "1", null, ""))
            }else{
              dispatch(getAllRequestInfo("1", "1", null, ""))
            }
           
          }
        })
        .catch((err) => {
          toast.error(err.response.data.body.message);
        });
        
    }
  
  };
  const sowRequestHandler = (id, data) => {
    console.log("sow data  ", data);
    setSOWModal(!modal);
    setSOWData(data);
    setEmployeeID(id);
    setSOWHistory(data?.activity?.filter((obj) => obj.action.includes("SOW")));
  };

  const handleOnCancel = (e) => {
    
    setInterviewRejectReason(e.target.value);
    if (e.target.value) {
      setIsButtonDisabled(false);
    }
    setErrors({ ...errors, interviewRejectReason: null });
  };
  const viewHandler = (dataObj) => {
    setBookingData(dataObj);
    setBookingModal(true);
  };
  const handleCancelInterview = (dataObj) => {
    // close();
    setBookingData(dataObj)
    console.log("modal", modal);
    setCancelModal(true);
  };
  const totalPendingCount = useSelector(
    (state) => state.PendingCountRequestReducer.result
  );
  const submit = () => {
    axiosAccountInstance
      .delete(`/deletebooking?id=${deleteId}`)
      .then((result) => {
        // dispatching success
        if (result.data.statusCode === 200) {
          toast.success(result.data.body.message);
          socketInstance.emit("message", {
            type: "UPDATE_DELETE_BOOKING",
            key: deleteId,
            extraInfo: fetchUserData().companyName,
          });

          dispatch(setPendingRequestInfo("1", "1", null, null));
          const currentCount=totalPendingCount?.outbound_bookings?.length > 0 ? (totalPendingCount?.outbound_bookings[0]?.pending_requests)-1 : 0
        
          dispatch(updatePendingCount("OUTBOUND_PENDING_LIST_COUNT_UPDATE",currentCount));
        }
      })
      .catch((err) => {
        toast.error(err.response.data.body.message);
      });
    setModal(false);
  };
  const colums = [
    { columnName: "Employee ID", columnTag: "empId", type: "data" },

    // { columnName: "Company", columnTag: "parentCompany", type: "data" },
    { columnName: "Designation", columnTag: "designation", type: "data" },
    { columnName: "Date Range", columnTag: "duration", type: "objectData" },
    {
      columnName: "Hourly Rate",
      columnTag: "hourlyPayment",
      type: "paymentMapping",
    },
    // { columnName: "Currency", columnTag: "currencyCode", type: "data" },
    {
      columnName: "SOW",
      columnTag: "sow_final_status",
      type: "data",
      actionSOWApprove: sowRequestHandler,
    },
    { columnName: "Status", columnTag: "status", type: "data" },
    { columnName: "", columnTag: "", type: " " },
  ];
  const actionbuttons = [
    {
      columnName: "",
      btnTitle: "View",
      btnTooltip: "View",
      type: "actionButton",
      btn: "ViewBooking",
      btnType: "primary",
      btnIcon: viewIcn,
      actionFunction: viewHandler,
    },
    {
      columnName: "",
      btnTitle: "Delete",
      btnTooltip: "Delete",
      type: "actionButton",
      btn: "PendingBookingDelete",
      icon: <i className="fa fa-trash" aria-hidden="true"></i>,
      tooltip: "Delete",
      btnType: "danger",
      btnIcon: deleteIcn,
      actionFunction: deleteHandler,
    },
     {
      columnName: "",
      btnTitle: "Cancel",
      btnTooltip: "Cancel",
      type: "actionButton",
      btn: "CancelInterview",
      icon: <i className="fa fa-trash" aria-hidden="true"></i>,
      tooltip: "Delete",
      btnType: "danger",
      btnIcon: cancelIcn,
      actionFunction: handleCancelInterview,
    },
  ];
  const handleOnSOWRejectChange = (e) => {
    setRejectRequestReason(e.target.value);
    setSOWErrors({ ...sowErrors, rejectRequestReason: null });
  };
  const imageSelect = (image) => {
    // if (image) {
    //   setIsRejectButtonDisabled(false);
    // }

    const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB maximum size limit
    if (image.size > MAX_IMAGE_SIZE) {
      setErrors({
        ...errors,
        sowDocument: `File size exceeds the maximum limit of ${
          MAX_IMAGE_SIZE / (1024 * 1024)
        }MB`,
      });
      setSignedSOWdoc(null);
      setIsApproveButtonDisabled(true);
    } else {
      setErrors({ ...errors, sowDocument: null });

      setSignedSOWdoc(image);
      setIsApproveButtonDisabled(false);
    }
    // setErrors({ ...errors, sowDocument: null });
    // setApproveFormData({
    //   ...approveFormData,
    //   sowDocument: image,
    // });
    // setIsApproveButtonDisabled(false);
  };
  const onApproveSOW = async () => {
    setIsApproveButtonDisabled(true);

    const data = new FormData();
    data.append("_id", employeeID);
    data.append("sow_status", "approved");
    data.append("sowSignedDocument", signedSOWdoc);

    submitRequest(data, "approved");
  };
  const onReject = () => {
    // setIsRejectButtonDisabled(true);
    const finalData = {
      _id: employeeID,
      sow_status: "rejected",
      rejectReason: rejectRequestReason,
    };
    submitRequest(finalData, "rejected");
  };
  const validationSOW = () => {
    const errorsFound = {};

    if (!rejectRequestReason || rejectRequestReason === "") {
      errorsFound["rejectRequestReason"] = "Reject Request Reason is required";
    }

    if (Object.keys(errorsFound).length !== 0) {
      setSOWErrors(errorsFound);
      return false;
    }
    return true;
  };
  const submitRequest = (data, type) => {
    if (data.sow_status === "rejected") {
      const isValid = validationSOW(data);
      setCompanyApproval(isValid, data, type);
    } else {
      setCompanyApproval(true, data, type);
    }
  };
  const setCompanyApproval = (isValid = true, data, requesttype) => {
    if (isValid) {
      axiosAccountInstance
        .post("/booking/final/sow_request/approve", data)
        .then((res) => {
          if (res.data.statusCode === 200) {
            if (requesttype === "approved") {
              socketInstance.emit("message", {
                type: "UPDATE_FINAL_SOW_REQUEST",
                subType: "UPDATE_FINAL_SOW_APPROVED_REQUEST_LIST",
                key: sowData?.bookingId,
                extraInfo: fetchUserData()?.companyName,
              });
              toast.success(res.data.body.message);
            } else {
              socketInstance.emit("message", {
                type: "UPDATE_FINAL_SOW_REQUEST",
                subType: "UPDATE_FINAL_SOW_REJECTED_REQUEST_LIST",
                key: sowData?.bookingId,
                extraInfo: fetchUserData()?.companyName,
              });
              toast.success(res.data.body.message);
            }

            dispatch(getApprovedRequestsInfo("1", "1", "approved"));
            setSOWModal(false);
          }
        })
        .catch((err) => {
          toast.error(err.response.data.body.message);
        });
      setRejectRequestReason("");
    }
  };
  const close = () => {
    setModal(false);
    setBookingModal(false);
    setSOWModal(false);
    setSOWData({});
    setCancelModal(false)
    setErrors("")
  };

  return (
    <div>
      {data && (
        <Tables
        isAllRequest={true}
          loader={loader}
          coloums={colums}
          data={fetchResultPendingListRequests?.booking}
          actionButtons={actionbuttons}
        />
      )}

      <Modal toggle={close} size="sm" centered isOpen={modal}>
        <Row>
          <div className="col">
            <ModalHeader className="text-uppercase font-weight-bolder">
              {" "}
              Delete Request
            </ModalHeader>
          </div>
          <Row>
            <Col>
              <ModalHeader className="text-uppercase">
                <Button onClick={close} className="mx-1" close />
              </ModalHeader>
            </Col>
          </Row>
        </Row>
        <ModalBody>
          <label className="font-weight-normal">
            Do you want to delete booking?
          </label>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" onClick={submit} color="danger">
            Delete
          </Button>{" "}
          {/* <Button size="sm" onClick={close}>
                  Cancel
                </Button> */}
        </ModalFooter>
      </Modal>
      <Modal toggle={close} centered isOpen={cancelModal}>
            <Row>
              <div className="col">
                <ModalHeader className="text-uppercase font-weight-bolder">
                  Cancel Interview Request
                </ModalHeader>
              </div>
              <Row>
                <Col>
                  <ModalHeader className="text-uppercase pt-3 pb-2">
                    <Button onClick={close} className="mx-1" close />
                  </ModalHeader>
                </Col>
              </Row>
            </Row>
            <ModalBody>
              <label className="font-weight-normal">
                Do you want to cancel the interview?
              </label>
              <FormGroup row>
                <Label for="exampleText" sm={12}>
                  Reason
                  <span style={{ color: "red" }}>*</span>
                </Label>
                <Col sm={12}>
                  <Input
                    id="exampleText"
                    name="text"
                    type="textarea"
                    onChange={handleOnCancel}
                    value={interviewRejectReason}
                    invalid={!!errors && !!errors.interviewRejectReason}
                  />
                  <FormFeedback
                    className={errors?.interviewRejectReason && "invalid-field"}
                  >
                    {errors?.interviewRejectReason}
                  </FormFeedback>
                </Col>
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                size="sm"
                onClick={() => onCancel()}
                color="primary"
                disabled={isButtonDisabled}
              >
                Submit
              </Button>{" "}
            </ModalFooter>
          </Modal>
      <SOWModal
        isOpen={sowModal}
        closeModal={close}
        sowData={sowData}
        onApproveSOW={onApproveSOW}
        onReject={onReject}
        sowHistory={sowHistory}
        handleOnSOWRejectChange={handleOnSOWRejectChange}
        rejectRequestReason={rejectRequestReason}
        isApproveButtonDisabled={isApproveButtonDisabled}
        sowErrors={sowErrors}
        imageSelect={imageSelect}
      />
      <BookingModal modal={bookingModal} close={close} data={bookingData} deleteHandler={deleteHandler} />
    </div>
  );
}

export default PendingListCard;
